import { render, staticRenderFns } from "./formKemajuanPerizinan.vue?vue&type=template&id=4f88d51a&scoped=true&"
import script from "./formKemajuanPerizinan.vue?vue&type=script&lang=js&"
export * from "./formKemajuanPerizinan.vue?vue&type=script&lang=js&"
import style0 from "./formKemajuanPerizinan.vue?vue&type=style&index=0&id=4f88d51a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88d51a",
  null
  
)

export default component.exports